<script setup lang="ts">
import ShowMapButton from './ShowMapButton.vue';
import ShowListButton from './ShowListButton.vue';
import { ViewType } from './map-constants';

defineProps<{ currentView: ViewType }>();

const emit = defineEmits<{(event: 'set-view', view: ViewType): void }>();
</script>

<template>
  <div class="sticky-tabs">
    <!-- @TODO: Add share button, @see https://bureaux-a-partager.atlassian.net/browse/MATCH-8196 -->

    <ShowListButton
      v-if="currentView === ViewType.MAP"
      class="!bottom-6"
      @click="emit('set-view', ViewType.LIST)"
    />

    <ShowMapButton
      v-else
      @click="emit('set-view', ViewType.MAP)"
    />
  </div>
</template>
